import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type CGMCalibrationPayload = {
  value?: number;
};

export type CGMCalibrationEvent = CGMCalibrationPayload;

const cGMCalibrationSchema = z.object({
  value: cz.permissive(z.number()),
});

export const LID_CGM_CALIBRATION_GX = {
  value: 0xd2,
  name: "CGM Calibration GX",
  format: "s..............",
  fields: ["value"],
  postprocess: rec => rec,
  schema: cGMCalibrationSchema,
} as const satisfies TandemEventDefinition<CGMCalibrationPayload, CGMCalibrationEvent>;
